// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function inputFile() {

    var self = this,
        defaultText = false,
        $cache = {};

    /**
     * Input on Change
     */
    function onChange(e) {
      var $input = $(this);
      var files = $input.prop('files');
      var filename = defaultText;

      if(files !== undefined && files.length > 0) {
        filename = files[0].name;
      }

      $cache.label.html(filename);
    }
    
    /**
     * Init Cache
     */
    function initCache(target) {
      $cache.html = $('html');
      $cache.main = target;

      $cache.input = $cache.main.find('input[type="file"]');
      $cache.label = $cache.main.find('label');
    }

    /**
     * Register Events
     */
    function registerEvents() {
      $cache.input.on('change', onChange);
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(target) {      
      initCache(target);

      defaultText = $cache.label.data('default');

      registerEvents();
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.inputFile = inputFile;
  
}(jQuery));
